<template>
  <div class="page" v-if="show">
    <!-- <header class="header">拍卖场次</header> -->

    <div class="main auction" id="-1">
      <!-- <div
        class="thumb"
        :style="'background-image: url(' + info.thumb + ')'"
      ></div> -->
      <img class="thumb" :src="info.thumb" alt="" />
      <div class="info">
        <div class="title"><span class="i"></span> {{ info.title }}</div>
        <div class="sub" v-if="info.time">
          <b>开拍时间：</b>{{ info.time.date }}
          {{ info.time.time }}
        </div>
        <div class="sub"><b>拍品数量：</b>{{ goodsList.length }} 件</div>
        <div class="sub" v-if="info.desc">{{ info.desc }}</div>
      </div>
      <div class="tools">
        <div class="item" @click="$router.push('/' + shop_id)">
          <svg
            t="1642045901908"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="10362"
            width="32"
            height="32"
          >
            <path
              d="M979.792374 404.577188 574.183101 83.942886c-34.918864-27.694272-89.619352-27.694272-124.538216 0L44.207626 404.577188c-13.933143 11.008903-16.169326 31.134554-5.332437 44.895683s30.618512 16.169326 44.551655 5.332437l12.55703-10.320847 0 387.547791c0 54.872501 57.968755 95.983874 108.712918 95.983874l639.892491 0c50.22812 0 83.254829-38.531161 83.254829-95.983874L927.844112 445.860575l11.69696 8.944734c5.84848 4.644381 13.073072 6.880564 20.125651 6.880564 9.460776 0 18.921552-4.128339 25.286074-12.213002C995.9617 435.711742 993.725517 415.586091 979.792374 404.577188zM479.919368 864.026877 479.919368 686.508315c0-8.77272 15.997312-13.245087 31.994625-13.245087s31.994625 4.472367 31.994625 13.245087l0 177.346548L479.919368 864.026877 479.919368 864.026877zM864.026877 832.032253c0 21.157736-5.84848 31.994625-19.26558 31.994625L608.585923 864.026877c0-0.516042-0.688056-0.860071-0.688056-1.376113L607.897867 686.508315c0-37.155048-29.930455-77.234336-95.983874-77.234336s-95.983874 40.079288-95.983874 77.234336l0 176.142449c0 0.516042 0.860071 0.860071 0.860071 1.376113L204.868806 864.026877c-20.125651 0-44.723669-17.373425-44.723669-31.994625L160.145137 393.740299 488.864102 134.171006c11.868974-9.288762 33.198723-9.288762 44.895683 0l330.095078 261.11742L863.854863 832.032253z"
              p-id="10363"
              fill="#E02F21"
            ></path></svg
          >前往首页
        </div>
        <div class="item" @click="$router.push('/kefu/' + shop_id)">
          <svg
            t="1642045861593"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="9479"
            width="32"
            height="32"
          >
            <path
              d="M820.409449 797.228346q0 25.19685-10.07874 46.866142t-27.716535 38.299213-41.322835 26.204724-50.897638 9.574803l-357.795276 0q-27.212598 0-50.897638-9.574803t-41.322835-26.204724-27.716535-38.299213-10.07874-46.866142l0-675.275591q0-25.19685 10.07874-47.370079t27.716535-38.80315 41.322835-26.204724 50.897638-9.574803l357.795276 0q27.212598 0 50.897638 9.574803t41.322835 26.204724 27.716535 38.80315 10.07874 47.370079l0 675.275591zM738.771654 170.330709l-455.559055 0 0 577.511811 455.559055 0 0-577.511811zM510.992126 776.062992q-21.165354 0-36.787402 15.11811t-15.622047 37.291339q0 21.165354 15.622047 36.787402t36.787402 15.622047q22.173228 0 37.291339-15.622047t15.11811-36.787402q0-22.173228-15.11811-37.291339t-37.291339-15.11811zM591.622047 84.661417q0-8.062992-5.03937-12.598425t-11.086614-4.535433l-128 0q-5.03937 0-10.582677 4.535433t-5.543307 12.598425 5.03937 12.598425 11.086614 4.535433l128 0q6.047244 0 11.086614-4.535433t5.03937-12.598425z"
              p-id="9480"
              fill="#E02F21"
            ></path></svg
          >联系客服
        </div>
        <div class="item" @click="$router.push('/wechat/' + shop_id)">
          <svg
            t="1642045990855"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1258"
            width="32"
            height="32"
          >
            <path
              d="M767.818667 409.173333C867.338667 444.266667 938.666667 539.136 938.666667 650.666667c0 42.709333-10.496 83.978667-30.261334 120.842666-1.792 3.338667-4.992 8.928-9.696 16.96l14.613334 53.557334c6.506667 23.893333-15.402667 45.813333-39.296 39.296l-53.642667-14.634667-6.229333 3.669333A254.933333 254.933333 0 0 1 682.666667 906.666667c-77.994667 0-147.84-34.88-194.805334-89.888a352.608 352.608 0 0 1-56.64 4.554666c-63.338667 0-124.266667-16.853333-177.472-48.298666-1.834667-1.088-6.410667-3.733333-13.632-7.893334l-80.544 21.653334c-23.914667 6.432-45.76-15.573333-39.146666-39.434667l21.792-78.752a961.205333 961.205333 0 0 1-15.904-27.317333A336.384 336.384 0 0 1 85.333333 480c0-188.618667 154.965333-341.333333 345.888-341.333333 159.914667 0 297.984 108.010667 335.818667 259.296 0.949333 3.765333 1.173333 7.552 0.778667 11.2z m-68.106667-13.952C662.88 282.037333 555.178667 202.666667 431.221333 202.666667 275.434667 202.666667 149.333333 326.933333 149.333333 480c0 46.272 11.498667 90.837333 33.194667 130.698667 2.88 5.290667 10.176 17.706667 21.621333 36.746666a32 32 0 0 1 3.413334 25.013334l-10.517334 37.994666 39.232-10.549333a32 32 0 0 1 24.234667 3.146667c14.272 8.192 22.773333 13.098667 25.802667 14.890666A283.882667 283.882667 0 0 0 431.221333 757.333333c6.154667 0 12.288-0.192 18.389334-0.576A255.061333 255.061333 0 0 1 426.666667 650.666667c0-141.386667 114.613333-256 256-256 5.728 0 11.413333 0.192 17.045333 0.554666z m133.706667 397.056a32 32 0 0 1 3.338666-24.725333 996.672 996.672 0 0 0 15.242667-26.293333A190.997333 190.997333 0 0 0 874.666667 650.666667c0-106.037333-85.962667-192-192-192s-192 85.962667-192 192 85.962667 192 192 192a190.933333 190.933333 0 0 0 98.570666-27.2c2.208-1.322667 8.288-4.874667 18.517334-10.837334a32 32 0 0 1 24.522666-3.210666l12.565334 3.424-3.424-12.565334zM330.666667 426.666667a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m192 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m85.333333 202.666666a32 32 0 1 1 0-64 32 32 0 0 1 0 64z m149.333333 0a32 32 0 1 1 0-64 32 32 0 0 1 0 64z"
              p-id="1259"
              fill="#E02F21"
            ></path></svg
          >加我微信
        </div>
      </div>

      <div class="goods-list">
        <div
          class="goods-item"
          v-for="(goods, key) in goodsList"
          :key="key"
          :id="key"
        >
          <div :id="goods.id" class="goods-container" @click="goto(goods.id)">
            <div
              class="goods-thumb"
              :style="'background-image: url(' + goods.thumb + ')'"
            ></div>
            <div class="goods-title">
              Lot {{ goods.order_by }} {{ goods.name }}
            </div>
            <div class="goods-option">
              编号：{{ goods.jigou }} {{ goods.dengji }} {{ goods.sn }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scord>
</style>

<script>
export default {
  data() {
    return {
      show: false,
      shop_id: null,
      info: {},
      shopInfo: {},
      goodsList: [],
    };
  },
  async mounted() {
    this.shop_id = this.$route.params.shop_id;

    const id = this.$route.query.id;
    const r = await this.$axios.get("/auction/getInfo?id=" + id);
    console.log(r);
    this.show = true;

    if (r.status == 1) {
      this.info = r.info;
      this.goodsList = r.goodsList;
      this.shopInfo = r.shopInfo;
    }

    this.$nextTick(() => {
      const hash = localStorage.getItem("hash") || "-1";
      location.hash = hash;
    });

    const that = this;
    // --------------- 获取signature ---------------
    const fullPath = this.$config.domain + this.$route.fullPath;

    this.signature = await this.$axios.post("/getSignature", {
      url: fullPath,
    });

    wx.config({
      debug: false,
      appId: this.signature.appId,
      timestamp: Number(this.signature.timestamp),
      nonceStr: this.signature.nonceStr,
      signature: this.signature.signature,
      jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
    });

    wx.ready(function () {
      //--------------- 分享 ---------------
      wx.updateAppMessageShareData(
        {
          title: that.info.title + " -- 微拍预展平台", // 分享标题
          desc:
            that.info.time.date +
            " " +
            that.info.time.time +
            " " +
            that.info.desc, // 分享描述
          link: fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.shopInfo.logo, // 分享图标
        },
        function (res) {
          console.log(res, 11122);
          //这里是回调函数
        }
      );

      wx.updateTimelineShareData(
        {
          title: that.info.title + " -- 微拍预展平台", // 分享标题
          link: fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.shopInfo.logo, // 分享图标
        },
        function (res) {
          //这里是回调函数
        }
      );
    });
    wx.error(function (res) {
      console.error(res, "---------------错误信息---------------");
    });
  },

  methods: {
    goto(id) {
      localStorage.setItem("hash", id.toString());
      this.$router.push("/goods/" + this.shop_id + "/" + id);
    },
  },
};
</script>